import { Content } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import { createTitle } from "@/functions/createTitle";
import { branch_helper } from "@/helpers/branch_helper";

export default function BranchesPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const title = "Our Branches";
  const branches = branch_helper.fetch({ filter: (branch) => branch.show_on_our_branches });

  return {
    props: {
      meta: {
        title: createTitle(title),
        canonical: "https://www.bluearrow.co.uk" + getRoute("branches")
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Contact us", href: getRoute("contact") },
              { label: title, href: getRoute("branches") },
            ],
          },
        },
        {
          component: "Header",
          props: {
            className: "text-tertiary",
            title: {
              path: "page.branches.component.Header.title",
              placeholder:
                `<h2 class='h1'>${title}</h2>`,
              tag: "h2",
              className: "h1 m-0",
            },
          },
        },
        {
          component: "BranchLookupPanel",
          props: { branches },
        },
        {
          component: "BranchList",
          props: { branches },
        },
        {
          component: "RichText",
          props: {
            className: "mb-4",
            containerClassName: null,
            body: {
              path: `page.our_branches.component.RichText.body`
            },
          },
        },
      ],
    },
  };
}
